var Parent_CHILD_ROLE = {
  'menubar': 'menuitem',
  'menu': 'menuitem',
  'menuitem': 'menu',
  'listbox': 'option'
};
module.exports = {
  getRole: function getRole(parent) {
    return Parent_CHILD_ROLE[parent] || null;
  }
};